import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw3-flex tw3-flex-col tw3-gap-6 md:tw3-flex-row" }
const _hoisted_2 = { class: "tw3-flex tw3-flex-1 tw3-flex-col tw3-gap-2.5" }
const _hoisted_3 = { class: "tw3-grid tw3-gap-2 sm:tw3-grid-cols-2" }
const _hoisted_4 = ["disabled", "onClick"]
const _hoisted_5 = { class: "tw3-min-w-0 tw3-flex-1 tw3-text-sm tw3-font-semibold" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "tw3-flex-1 tw3-text-sm tw3-font-semibold" }
const _hoisted_8 = {
  key: 0,
  class: "tw3-rounded-xl tw3-border tw3-border-surface-200 tw3-bg-surface-50 tw3-p-4"
}
const _hoisted_9 = { class: "tw3-flex tw3-flex-wrap tw3-items-center tw3-justify-between tw3-gap-3" }
const _hoisted_10 = { class: "tw3-flex tw3-shrink-0 tw3-items-center tw3-gap-1 tw3-rounded-full tw3-border tw3-border-surface-200 tw3-bg-surface-0 tw3-p-1 tw3-shadow-sm" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "tw3-flex tw3-min-w-0 tw3-flex-1 tw3-items-center tw3-gap-2" }
const _hoisted_13 = { class: "tw3-text-sm tw3-font-semibold" }
const _hoisted_14 = { class: "tw3-text-sm tw3-font-bold tw3-text-primary-700" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "pi pi-check !tw3-text-[0.7rem]"
}
const _hoisted_17 = {
  key: 1,
  class: "pi pi-plus !tw3-text-[0.7rem]"
}
const _hoisted_18 = { class: "tw3-flex-1 tw3-text-sm tw3-font-semibold" }
const _hoisted_19 = {
  key: 0,
  class: "bip-gradient tw3-flex tw3-w-full tw3-flex-col tw3-rounded-2xl tw3-p-6 tw3-text-white tw3-shadow-lg md:tw3-mt-[1.25rem] md:tw3-self-stretch sm:tw3-w-[18rem]",
  style: {"height":"fit-content"}
}
const _hoisted_20 = { class: "tw3-mt-2 tw3-flex tw3-items-start tw3-leading-none" }
const _hoisted_21 = { class: "tw3-text-[3.5rem] tw3-font-extrabold" }
const _hoisted_22 = { class: "tw3-ml-0.5 tw3-mt-1.5 tw3-text-xl tw3-font-bold tw3-underline tw3-underline-offset-2" }
const _hoisted_23 = { class: "tw3-mt-4 tw3-grid tw3-gap-2 tw3-border-t tw3-border-white/25 tw3-pt-3" }
const _hoisted_24 = { class: "tw3-flex tw3-items-center tw3-justify-between tw3-text-sm" }
const _hoisted_25 = { class: "tw3-m-0 tw3-font-semibold" }
const _hoisted_26 = { class: "tw3-flex tw3-items-center tw3-justify-between tw3-text-sm" }
const _hoisted_27 = { class: "tw3-m-0 tw3-font-semibold" }
const _hoisted_28 = {
  key: 0,
  class: "tw3-flex tw3-items-center tw3-justify-between tw3-text-sm"
}
const _hoisted_29 = { class: "tw3-m-0 tw3-font-semibold" }
const _hoisted_30 = { class: "tw3-flex tw3-items-center tw3-justify-between tw3-text-sm" }
const _hoisted_31 = { class: "tw3-m-0 tw3-font-semibold" }
const _hoisted_32 = { class: "tw3-mt-1 tw3-flex tw3-items-center tw3-justify-between tw3-border-t tw3-border-white/25 tw3-pt-2.5 tw3-text-base tw3-font-bold" }
const _hoisted_33 = { class: "tw3-m-0" }
const _hoisted_34 = {
  key: 1,
  class: "-tw3-mx-3 tw3-mt-1 tw3-flex tw3-items-center tw3-justify-between tw3-rounded-lg tw3-bg-white/15 tw3-px-3 tw3-py-2.5 tw3-text-base tw3-font-bold"
}
const _hoisted_35 = { class: "tw3-m-0" }

import { computed } from 'vue';

import {
	MAX_REPAIR_CHIP_COUNT,
	MIN_REPAIR_CHIP_COUNT,
	useBookingQuoteStore
} from '@/entities/quickQuote/lib/booking-store';
import { formatMoney } from '@/shared/helpers/formatters';

import type {
	BookingGlassOptionKey,
	EstimateOption
} from '@/entities/quickQuote/lib/booking-api.types';


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingItemPricing',
  setup(__props) {

const bookingStore = useBookingQuoteStore();

const isSelected = (item: EstimateOption) =>
	bookingStore.selectedExtraOptionKeys.includes(item.key);

const glassOptions = computed(() => bookingStore.availableGlassOptions);
const extraItems = computed(() =>
	bookingStore.selectableExtraOptions.filter(item => item.key !== 'mobileFee')
);
const fixedExtraItems = computed(() => bookingStore.requiredRecalOptions);
const hasExtraItems = computed(
	() => fixedExtraItems.value.length > 0 || extraItems.value.length > 0
);
const selectedGlassKey = computed({
	get: () => bookingStore.selectedGlassOption,
	set: (value: BookingGlassOptionKey) => {
		bookingStore.setSelectedGlassOption(value);
	}
});
const chipCount = computed({
	get: () => bookingStore.chipCount,
	set: value => {
		bookingStore.setChipCount(value);
	}
});
const chipCountChoices = Array.from(
	{ length: MAX_REPAIR_CHIP_COUNT - MIN_REPAIR_CHIP_COUNT + 1 },
	(_, index) => MIN_REPAIR_CHIP_COUNT + index
);

const optionClass = (item: EstimateOption) => {
	if (isSelected(item)) {
		return 'tw3-cursor-pointer tw3-border-primary-500 tw3-bg-primary-50 tw3-text-surface-900 tw3-shadow-sm';
	}

	return 'tw3-cursor-pointer tw3-border-surface-200 tw3-bg-surface-0 tw3-text-surface-800 hover:tw3-border-primary-300 hover:tw3-bg-surface-50';
};

const checkClass = (item: EstimateOption) => {
	if (isSelected(item)) return 'tw3-bg-primary-500 tw3-text-white';
	return 'tw3-border tw3-border-surface-300 tw3-text-surface-400';
};

const selectItem = (item: EstimateOption) =>
	bookingStore.toggleExtraOption(item);

const serviceLocationItems = computed(() => {
	const requiredMobileFee = bookingStore.requiredMobileFeeOption;
	const optionalMobileFee = bookingStore.optionalMobileFeeOption;

	if (requiredMobileFee) {
		return [
			{
				key: 'mobile',
				label: 'We come to you',
				price: bookingStore.getOptionCost(requiredMobileFee).total,
				selected: true,
				disabled: true
			}
		];
	}

	return [
		{
			key: 'inShop',
			label: 'You come to us',
			price: 0,
			selected: !bookingStore.selectedExtraOptionKeys.includes('mobileFee'),
			disabled: !optionalMobileFee
		},
		...(optionalMobileFee
			? [
					{
						key: 'mobile',
						label: 'We come to you',
						price: bookingStore.getOptionCost(optionalMobileFee).total,
						selected:
							bookingStore.selectedExtraOptionKeys.includes('mobileFee'),
						disabled: false
					}
				]
			: [])
	];
});

const selectServiceLocation = (key: string) => {
	const mobileFee = bookingStore.optionalMobileFeeOption;
	if (!mobileFee) return;

	const mobileSelected =
		bookingStore.selectedExtraOptionKeys.includes('mobileFee');

	if (key === 'mobile' && !mobileSelected) {
		bookingStore.toggleExtraOption(mobileFee);
	}

	if (key === 'inShop' && mobileSelected) {
		bookingStore.toggleExtraOption(mobileFee);
	}
};

const serviceLocationClass = (item: {
	selected: boolean;
	disabled: boolean;
}) => {
	if (item.selected) {
		return item.disabled
			? 'tw3-cursor-default tw3-border-primary-500 tw3-bg-primary-50 tw3-text-surface-900 tw3-shadow-sm'
			: 'tw3-cursor-pointer tw3-border-primary-500 tw3-bg-primary-50 tw3-text-surface-900 tw3-shadow-sm';
	}

	return 'tw3-cursor-pointer tw3-border-surface-200 tw3-bg-surface-0 tw3-text-surface-800 hover:tw3-border-primary-300 hover:tw3-bg-surface-50';
};

const glassOptionPrice = (key: BookingGlassOptionKey) => {
	const option = glassOptions.value.find(item => item.key === key);
	if (!option) return 0;
	if (option.key === 'replace') return bookingStore.getOptionCost(option).total;

	const chipOption = option.chipOptions.find(
		item => item.chipCount === chipCount.value
	);
	return chipOption ? bookingStore.getOptionCost(chipOption).total : 0;
};

const dollars = computed(() => {
	let amount = '0';
	if (pricing.value) {
		const { total } = pricing.value;
		if (total.toString().includes('.')) {
			const pieces = pricing.value.total.toString().split('.');
			amount = pieces[0];
		} else {
			amount = total.toString();
		}
	}

	return amount;
});

const cents = computed(() => {
	let amount = '00';
	if (pricing.value) {
		const { total } = pricing.value;
		if (total.toString().includes('.')) {
			const pieces = pricing.value.total.toString().split('.');
			amount = pieces[1];
			if (pieces[1].length < 2) {
				amount = amount + '0';
			}
		}
	}

	return amount;
});

const pricing = computed(() =>
	bookingStore.selectedGlass ? bookingStore.quoteCost : null
);
const estimatedTax = computed(() =>
	pricing.value ? pricing.value.materialTax + pricing.value.laborTax : 0
);

const mobileFeeCost = computed(() => bookingStore.mobileFeeCost);
const mobileFeeAmount = computed(() =>
	mobileFeeCost.value
		? mobileFeeCost.value.materials + mobileFeeCost.value.labor
		: null
);

const materialsAmount = computed(() =>
	pricing.value
		? pricing.value.materials - (mobileFeeCost.value?.materials ?? 0)
		: 0
);
const laborAmount = computed(() =>
	pricing.value ? pricing.value.labor - (mobileFeeCost.value?.labor ?? 0) : 0
);
// const hasShopLocation = computed(() => {
// 	const address = bookingStore.shopAddress;
// 	return Boolean(
// 		address &&
// 			address?.lat &&
// 			address?.lng &&
// 			Number.isFinite(Number(address.lat)) &&
// 			Number.isFinite(Number(address.lng))
// 	);
// });
// const shouldShowShopLocationMap = computed(
// 	() => Boolean(hasShopLocation.value) && !bookingStore.requiredMobileFeeOption
// );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serviceLocationItems.value, (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.key,
            class: _normalizeClass(["tw3-flex tw3-w-full tw3-items-center tw3-justify-between tw3-gap-3 tw3-rounded-xl tw3-border tw3-px-4 tw3-py-3 tw3-text-left tw3-transition-all", serviceLocationClass(item)]),
            disabled: item.disabled,
            type: "button",
            onClick: ($event: any) => (selectServiceLocation(item.key))
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["tw3-shrink-0 tw3-text-sm tw3-font-bold", 
							item.selected ? 'tw3-text-primary-700' : 'tw3-text-surface-500'
						])
            }, " +" + _toDisplayString(_unref(formatMoney)(item.price)), 3)
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "tw3-mt-3 tw3-text-xs tw3-font-bold tw3-uppercase tw3-tracking-wider tw3-text-surface-400" }, " Glass ", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(glassOptions.value, (option) => {
        return (_openBlock(), _createElementBlock("button", {
          key: option.key,
          class: _normalizeClass(["tw3-flex tw3-w-full tw3-items-center tw3-gap-3 tw3-rounded-xl tw3-border tw3-px-4 tw3-py-3 tw3-text-left tw3-transition-all", 
					selectedGlassKey.value === option.key
						? 'tw3-border-primary-500 tw3-bg-primary-50 tw3-text-surface-900 tw3-shadow-sm'
						: 'tw3-border-surface-200 tw3-bg-surface-0 tw3-text-surface-800 hover:tw3-border-primary-300 hover:tw3-bg-surface-50'
				]),
          type: "button",
          onClick: ($event: any) => (selectedGlassKey.value = option.key)
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["tw3-flex tw3-size-[1.4rem] tw3-shrink-0 tw3-items-center tw3-justify-center tw3-rounded-full tw3-p-1 tw3-transition-all", 
						selectedGlassKey.value === option.key
							? 'tw3-bg-primary-500 tw3-text-white'
							: 'tw3-border tw3-border-surface-300 tw3-text-surface-400'
					])
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["!tw3-text-[0.7rem]", 
							selectedGlassKey.value === option.key ? 'pi pi-check' : 'pi pi-circle'
						])
            }, null, 2)
          ], 2),
          _createElementVNode("span", _hoisted_7, _toDisplayString(option.label), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["tw3-text-sm tw3-font-bold", 
						selectedGlassKey.value === option.key
							? 'tw3-text-primary-700'
							: 'tw3-text-surface-500'
					])
          }, _toDisplayString(_unref(formatMoney)(glassOptionPrice(option.key))), 3)
        ], 10, _hoisted_6))
      }), 128)),
      (selectedGlassKey.value === 'repair')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[0] || (_cache[0] = _createElementVNode("div", null, [
                _createElementVNode("p", { class: "tw3-m-0 tw3-text-sm tw3-font-semibold tw3-text-surface-800" }, " Number of chips "),
                _createElementVNode("p", { class: "tw3-m-0 tw3-mt-1 tw3-text-xs tw3-text-surface-500" }, " More than 3 chips is usually better served by replacement. ")
              ], -1)),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chipCountChoices), (count) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: count,
                    class: _normalizeClass(["tw3-min-w-10 tw3-rounded-full tw3-px-3 tw3-py-1.5 tw3-text-sm tw3-font-bold tw3-transition-all", 
								chipCount.value === count
									? 'tw3-bg-primary-500 tw3-text-white tw3-shadow-sm'
									: 'tw3-bg-transparent tw3-text-surface-600 hover:tw3-bg-surface-100'
							]),
                    type: "button",
                    onClick: ($event: any) => (chipCount.value = count)
                  }, _toDisplayString(count), 11, _hoisted_11))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (hasExtraItems.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "tw3-mt-3 tw3-text-xs tw3-font-bold tw3-uppercase tw3-tracking-wider tw3-text-surface-400" }, " Extras ", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fixedExtraItems.value, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                key: item.key,
                class: "tw3-flex tw3-w-full tw3-cursor-default tw3-items-center tw3-gap-3 tw3-rounded-xl tw3-border tw3-border-primary-500 tw3-bg-primary-50 tw3-px-4 tw3-py-3 tw3-text-left tw3-text-surface-900 tw3-shadow-sm tw3-transition-all",
                disabled: "",
                type: "button"
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "tw3-flex tw3-size-[1.4rem] tw3-shrink-0 tw3-items-center tw3-justify-center tw3-rounded-full tw3-bg-primary-500 tw3-p-1 tw3-text-white tw3-transition-all" }, [
                  _createElementVNode("i", { class: "pi pi-check !tw3-text-[0.7rem]" })
                ], -1)),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(item.label), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "tw3-shrink-0 tw3-rounded-full tw3-bg-primary-100 tw3-px-2 tw3-py-0.5 tw3-text-[0.65rem] tw3-font-bold tw3-uppercase tw3-leading-none tw3-text-primary-700" }, " Required ", -1))
                ]),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(formatMoney)(_unref(bookingStore).getOptionCost(item).total)), 1)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraItems.value, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                key: item.key,
                class: _normalizeClass(["tw3-flex tw3-w-full tw3-items-center tw3-gap-3 tw3-rounded-xl tw3-border tw3-px-4 tw3-py-3 tw3-text-left tw3-transition-all", optionClass(item)]),
                type: "button",
                onClick: ($event: any) => (selectItem(item))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["tw3-flex tw3-size-[1.4rem] tw3-shrink-0 tw3-items-center tw3-justify-center tw3-rounded-full tw3-p-1 tw3-transition-all", checkClass(item)])
                }, [
                  (isSelected(item))
                    ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                    : (_openBlock(), _createElementBlock("i", _hoisted_17))
                ], 2),
                _createElementVNode("span", _hoisted_18, _toDisplayString(item.label), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["tw3-text-sm tw3-font-bold", 
							isSelected(item) ? 'tw3-text-primary-700' : 'tw3-text-surface-500'
						])
                }, _toDisplayString(_unref(formatMoney)(_unref(bookingStore).getOptionCost(item).total)), 3)
              ], 10, _hoisted_15))
            }), 128))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (pricing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "tw3-flex tw3-items-center tw3-justify-between tw3-gap-4" }, [
            _createElementVNode("span", { class: "tw3-text-xs tw3-font-bold tw3-uppercase tw3-tracking-wide tw3-opacity-80" }, " Your price ")
          ], -1)),
          _createElementVNode("div", _hoisted_20, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "tw3-mt-1.5 tw3-text-2xl tw3-font-bold" }, "$", -1)),
            _createElementVNode("span", _hoisted_21, _toDisplayString(dollars.value), 1),
            _createElementVNode("span", _hoisted_22, _toDisplayString(cents.value), 1)
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "tw3-mt-0.5 tw3-text-xs tw3-opacity-80" }, "Tax included", -1)),
          _createElementVNode("dl", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _cache[6] || (_cache[6] = _createElementVNode("dt", { class: "tw3-opacity-80" }, "Materials", -1)),
              _createElementVNode("dd", _hoisted_25, _toDisplayString(_unref(formatMoney)(materialsAmount.value)), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _cache[7] || (_cache[7] = _createElementVNode("dt", { class: "tw3-opacity-80" }, "Labor", -1)),
              _createElementVNode("dd", _hoisted_27, _toDisplayString(_unref(formatMoney)(laborAmount.value)), 1)
            ]),
            (mobileFeeAmount.value !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _cache[8] || (_cache[8] = _createElementVNode("dt", { class: "tw3-opacity-80" }, "Mobile fee", -1)),
                  _createElementVNode("dd", _hoisted_29, _toDisplayString(_unref(formatMoney)(mobileFeeAmount.value)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              _cache[9] || (_cache[9] = _createElementVNode("dt", { class: "tw3-opacity-80" }, "Estimated tax", -1)),
              _createElementVNode("dd", _hoisted_31, _toDisplayString(_unref(formatMoney)(estimatedTax.value)), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _cache[10] || (_cache[10] = _createElementVNode("dt", null, "Quote total", -1)),
              _createElementVNode("dd", _hoisted_33, _toDisplayString(_unref(formatMoney)(pricing.value.total)), 1)
            ]),
            (_unref(bookingStore).paymentRequired)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("dt", null, "Due today " + _toDisplayString(_unref(bookingStore).dueTodayPercent), 1),
                  _createElementVNode("dd", _hoisted_35, _toDisplayString(_unref(formatMoney)(_unref(bookingStore).prepaymentAmount || 0)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})